import React from 'react';
import { Navigate } from 'react-router-dom';

interface PrivateRouteProps {
  children: JSX.Element;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const accessToken = sessionStorage.getItem('access_token');

  // Check if access_token exists in sessionStorage
  if (!accessToken) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PrivateRoute;